module.exports = __webpack_public_path__ + "account/assets/people.06c4b77c.svg";